import axios from 'axios'
import { apiUrl } from '../config'
import authenticationStore from '../stores/authenticationStore'

export const CateDocumentRequest = {
  // Incoming
  getDocumentsIncoming: params =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/cate-documents/incoming`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      params: params,
    }),
  getDocumentsOutgoing: params =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/cate-documents/outgoing`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      params: params,
    }),
  getDocumentsIncomingById: doc_id =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/cate-documents/incoming/${doc_id}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),
  getDocumentsOutgoingById: doc_id =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/cate-documents/outgoing/${doc_id}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),
  createCateDocument: documentInfo =>
    axios({
      method: 'post',
      url: `${apiUrl}/api/v1/cate-documents/outgoing`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: documentInfo,
    }),
  updateCateDocument: documentInfo =>
    axios({
      method: 'put',
      url: `${apiUrl}/api/v1/cate-documents/outgoing/${documentInfo.id}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: documentInfo,
    }),
  sentDocument: documentInfo =>
    axios({
      method: 'patch',
      url: `${apiUrl}/api/v1/cate-documents/outgoing/${documentInfo.id}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: documentInfo,
    }),
  reload: () =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/cate-documents/reload`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),
  reloadStatus: () =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/cate-documents/reload/status`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),
  updateReceivedStatus: documentInfo =>
    axios({
      method: 'patch',
      url: `${apiUrl}/api/v1/cate-documents/received/${documentInfo.id}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: documentInfo,
    }),
  reloadIncoming: documentInfo =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/cate-documents/reload/${documentInfo.id}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: documentInfo,
    }),
}
